module.exports = __webpack_public_path__ + "api-code-grab.7247f0.jpg";